import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type PnlTimeFrame =
  | 'weekly'
  | 'monthly'
  | '2month'
  | '3month'
  | '6month'
  | 'custom';

type PnlState = {
  timeFrame: PnlTimeFrame;
  customStartDate: string | null;
  customEndDate: string | null;
  selectedAssets: string[]; // Asset symbols to show PNL for
};

const initialState: PnlState = {
  timeFrame: 'weekly',
  customStartDate: null,
  customEndDate: null,
  selectedAssets: [] // Empty = show all assets
};

const pnl = createSlice({
  name: 'pnl',
  initialState,
  reducers: {
    setTimeFrame: (state, action: PayloadAction<PnlTimeFrame>) => {
      state.timeFrame = action.payload;

      // Clear custom dates if not custom mode
      if (action.payload !== 'custom') {
        state.customStartDate = null;
        state.customEndDate = null;
      }
    },

    setCustomDateRange: (
      state,
      action: PayloadAction<{ start: string; end: string }>
    ) => {
      state.customStartDate = action.payload.start;
      state.customEndDate = action.payload.end;
      state.timeFrame = 'custom';
    },

    // Select single asset (replaces any previous selection)
    selectAsset: (state, action: PayloadAction<string>) => {
      state.selectedAssets = [action.payload];
    },

    // Clear asset filter (show all)
    clearAssetFilter: (state) => {
      state.selectedAssets = [];
    },

    resetFilters: (state) => {
      state.timeFrame = 'weekly';
      state.customStartDate = null;
      state.customEndDate = null;
      state.selectedAssets = [];
    }
  }
});

export const {
  setTimeFrame,
  setCustomDateRange,
  selectAsset,
  clearAssetFilter,
  resetFilters
} = pnl.actions;
export default pnl.reducer;
